document.addEventListener("DOMContentLoaded", async () => {
  const stockEl = document.getElementById("cart-stock-data");
  if (!stockEl) return;

  const stockData = JSON.parse(stockEl.textContent);

  // Fetch the latest cart
  const cartResponse = await fetch('/cart.js');
  const cart = await cartResponse.json();

  for (const item of stockData.items) {
    const cartItem = cart.items.find(c => c.variant_id === item.id);
    if (!cartItem) continue;

    const cartOrderType = cartItem.properties?.["Order Type"] || null;

    // Determine if the item should be removed because it's unavailable
    const shouldRemove = !item.available && item.quantity_in_cart > 0;

    // Update Order Type only if item is available
    const shouldUpdateOrderType = item.available && item.preorder_notes && cartOrderType !== item.preorder_notes;

    // Skip if nothing to change
    if (!shouldRemove && !shouldUpdateOrderType) continue;

    const formData = {
      id: cartItem.key,
      quantity: shouldRemove ? 0 : cartItem.quantity,
      properties: shouldUpdateOrderType
        ? { ...cartItem.properties, "Order Type": item.preorder_notes }
        : cartItem.properties,
      sections: 'cart-drawer-template',
      sections_url: window.PXUTheme.routes.cart_url
    };

    try {
      const response = await fetch(window.PXUTheme.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      }).then(res => res.json());

      // --- Manual refresh cart drawer ---
      const sectionsHTML = response.sections['cart-drawer-template'];
      if (sectionsHTML) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionsHTML, 'text/html');
        const newCartDrawer = doc.querySelector('[data-cart-drawer]');
        const currentDrawer = document.querySelector('[data-cart-drawer]');
        if (currentDrawer && newCartDrawer) {
          currentDrawer.innerHTML = newCartDrawer.innerHTML;
          if(shouldRemove) {
            showCartValidationToast(`Sorry, <a href="${item.url}">${item.title}</a> is no longer available and has been removed from your cart.`);
          }
          console.log(`✅ Cart drawer updated: ${item.title}${shouldRemove ? " (removed)" : ""}`);
        }
      }

      // --- Update cart count in header ---
      const cartCountEl = document.querySelector('[data-cart-count]');
      if (cartCountEl) {
        cartCountEl.textContent = response.item_count || 0;
      }

    } catch (err) {
      console.error(`Error updating cart item "${item.title}":`, err);
    }
  }

  function showCartValidationToast(message) {
    const cartValidationToast = document.getElementById("cart-validation");
    cartValidationToast.innerHTML = message;
    cartValidationToast.classList.add("show");

    setTimeout(() => {
      cartValidationToast.classList.remove("show");
    }, 10000);
  }
  
});
